/*
  Verzekerde verzending (insured shipping) — cart toggle voor Moray
  Werkt samen met snippets/secured-shipping.liquid + assets/secured-shipping.css.

  1. Voegt een "shipping protection" productregel toe / verwijdert die
     wanneer het vinkje in de winkelwagen wordt aan-/uitgezet.
  2. De regel zelf is verborgen in de cart drawer en op /cart (CSS).
     Wanneer de laatste echte productregel verdwijnt, wordt de verzekering
     automatisch mee verwijderd zodat de cart netjes leeg is.
*/
(function () {
  'use strict';

  // De snippet staat zowel in de drawer als in de cart-footer; het script mag
  // maar een keer zijn listeners registreren.
  if (window.__moraySecuredShipping) return;
  window.__moraySecuredShipping = true;

  var TOGGLE = '[data-secured-shipping-toggle]';
  var ADDON_ROW = '[data-addon-line="secured-shipping"]';
  var VISIBLE_ROW = '.cart-item:not(.cart-item--addon-hidden)';

  var busy = false;

  function base() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function addUrl() { return base() + 'cart/add.js'; }
  function changeUrl() { return base() + 'cart/change.js'; }

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function setLoading(host, on) {
    if (!host) return;
    host.classList.toggle('is-loading', !!on);
    var input = host.querySelector(TOGGLE);
    if (input) input.disabled = !!on;
  }

  function refreshDrawer(parsed) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && parsed && parsed.sections) {
      drawer.renderContents(parsed);
      return true;
    }
    return false;
  }

  /* ---------------------------------------------------------------------
     Toggle aan/uit
  --------------------------------------------------------------------- */
  function onToggle(input) {
    var host = input.closest('secured-shipping') || input.closest('.secured-shipping');
    var variantId = input.getAttribute('data-variant-id');
    var inDrawer = !!input.closest('cart-drawer');
    if (!variantId) return;

    var wantOn = input.checked;
    setLoading(host, true);

    // Alleen de drawer weet zichzelf te herrenderen; op de /cart-pagina herladen we.
    var sections = inDrawer ? ['cart-drawer', 'cart-icon-bubble'] : undefined;
    var request;

    if (wantOn) {
      request = postJSON(addUrl(), {
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      });
    } else {
      request = postJSON(changeUrl(), {
        id: String(variantId),
        quantity: 0,
        sections: sections,
        sections_url: window.location.pathname
      });
    }

    request
      .then(function (parsed) {
        if (parsed && parsed.status && Number(parsed.status) >= 400) {
          throw new Error(parsed.description || parsed.message || 'Cart error ' + parsed.status);
        }
        if (inDrawer && refreshDrawer(parsed)) return;
        window.location.reload();
      })
      .catch(function (error) {
        input.checked = !wantOn;
        setLoading(host, false);
        console.error('[secured-shipping]', error);
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest ? e.target.closest(TOGGLE) : null;
    if (input) onToggle(input);
  });

  /* ---------------------------------------------------------------------
     Guard: verzekering nooit als enige regel in de cart laten staan
  --------------------------------------------------------------------- */
  function addonVariantId(row) {
    var qty = row.querySelector('[data-quantity-variant-id]');
    if (qty) return qty.getAttribute('data-quantity-variant-id');

    var remove = row.querySelector('cart-remove-button button[data-variant-id]');
    if (remove) return remove.getAttribute('data-variant-id');

    var toggle = document.querySelector(TOGGLE);
    return toggle ? toggle.getAttribute('data-variant-id') : null;
  }

  function pruneOrphanAddon() {
    if (busy) return;

    var addonRow = document.querySelector(ADDON_ROW);
    if (!addonRow) return;                             // verzekering zit niet in de cart
    if (document.querySelector(VISIBLE_ROW)) return;   // er staat nog een echt product in

    var variantId = addonVariantId(addonRow);
    if (!variantId) return;

    busy = true;

    var inDrawer = !!addonRow.closest('cart-drawer');
    postJSON(changeUrl(), {
      id: String(variantId),
      quantity: 0,
      sections: inDrawer ? ['cart-drawer', 'cart-icon-bubble'] : undefined,
      sections_url: window.location.pathname
    })
      .then(function (parsed) {
        if (inDrawer && refreshDrawer(parsed)) {
          busy = false;
          return;
        }
        window.location.reload();
      })
      .catch(function () {
        busy = false;
      });
  }

  var pruneTimer = null;
  function schedulePrune() {
    clearTimeout(pruneTimer);
    pruneTimer = setTimeout(pruneOrphanAddon, 120);
  }

  function watch() {
    schedulePrune();

    var observer = new MutationObserver(schedulePrune);
    ['#CartDrawer', '#main-cart-items', '#main-cart-footer'].forEach(function (selector) {
      var node = document.querySelector(selector);
      if (node) observer.observe(node, { childList: true, subtree: true });
    });

    // Dawn publiceert cart-updates via pubsub; meeliften waar beschikbaar.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, schedulePrune);
      } catch (e) {
        /* stil falen: de MutationObserver dekt het al af */
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
